import React, { forwardRef, LegacyRef } from 'react'

import MacOSCalendarImage from './MacOSCalendar.png'

export const MacOSCalendarIcon = forwardRef<
  HTMLImageElement,
  React.ImgHTMLAttributes<HTMLImageElement>
>((props, ref) => {
  return (
    <img
      alt='MacOS Calendar Icon'
      ref={ref as LegacyRef<HTMLImageElement>}
      width={24}
      height={24}
      {...props}
      src={MacOSCalendarImage}
    />
  )
})

MacOSCalendarIcon.displayName = 'MacOSCalendarIcon'

export default MacOSCalendarIcon
